import { Project } from "../models/Project";
import client from "./axios";

const projectsUrl = `${window.__env.KRAKEND_URL}/v1/projects`;

interface Asset {
  id?: number;
  type: string;
}

export enum ProcessType {
  STATUS_CHECK = "status_check",
  FULL_ASSESSMENT = "full_assessment",
}

export interface ModelAssessment {
  process_type: ProcessType;
  assessment_id: string;
  user_id: string;
  themis_user_id: string;
  frontend_metadata: any;
  tai_characteristics?: Array<string>;
}

export enum AssessmentStatus {
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  NONE = "",
}

export interface ModelAssessmentResponse {
  assessment_id: string;
  status: AssessmentStatus;
  state: string;
  error: any;
}

export const Projects = {
  getProjects: (params?: URLSearchParams) => client.get<Project[]>(projectsUrl, { params }),
  getProject: (id: number) => client.get<Project>(`${projectsUrl}/${id}`),
  createProject: (project: Project) => client.post<Project>(projectsUrl, project),
  updateProject: (project: Project) => client.put<Project>(`${projectsUrl}/${project.id}`, project),
  deleteProject: (id: number) => client.delete(`${projectsUrl}/${id}`),
  addAsset: (id: number, asset: Asset) => client.post<Project>(`${projectsUrl}/${id}/${asset.type}s/${asset.id}`, {}),
  removeAsset: (id: number, asset: Asset) => client.delete(`${projectsUrl}/${id}/${asset.type}s/${asset.id}`),
  getAssetProjects: (assetType: string, assetId: number) => client.get<Project[]>(`${projectsUrl}/by-asset/${assetType}/${assetId}`),
  getModelAssessment: (assessmentId: number) => client.get<ModelAssessmentResponse>(`${window.__env.MODEL_ASSESSMENTS_BASE_URL}/assessments/${assessmentId}/status`),
  assessModel: (body: ModelAssessment) => client.post<ModelAssessmentResponse>(`${window.__env.MODEL_ASSESSMENTS_BASE_URL}/start-assessment`, body),
}